export default __webpack_public_path__ + "ea61444df9c665a4dce0bc20e2b75938.png";